import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { DocumentiFTSearchFilters } from 'src/app/shared/models/documento-search.model';

@Component({
  selector: 'app-fulltext-search',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <h3>Ricerca libera</h3>
  <div class="full-text-search">
    <div class="search-controls">
      <div class="search-field flex flex-column gap-2">
        <label class="small-label" for="name">Testo</label>
        <input pInputText id="name" type="text" [(ngModel)]="searchTerm" #descriptionControl="ngModel"
          placeholder="testo da cercare" (keyup.enter)="doSearch()" autocomplete="off">
      </div>
      <div class="search-field flex flex-column gap-2">
        <label class="small-label" for="fulltextDataDocumento">Data Documento</label>
        <p-calendar [(ngModel)]="dataDocumento" inputId="fulltextDataDocumento" [selectOtherMonths]="true"
          dateFormat="dd/mm/yy" selectionMode="range" [showIcon]="true" [inputStyle]="{'width': '420px'}">
        </p-calendar>
      </div>
      <div class="search-buttons">
        <button pButton type="button" icon="fas fa-eraser" label="Pulisci" title="Pulisci" data-testid="clear-button"
          (click)="doClear()"></button>
        <button pButton type="button" icon="fa fa-search" label="Cerca" title="Cerca" data-testid="search-button"
          (click)="doSearch()"></button>
      </div>
    </div>
    <small id="username-help">
      Supporta <strong>*</strong> (asterisco) per ricerche parziali, <strong>" "</strong> (doppi apici) per ricerche esatte e gli operatori <strong>AND</strong> e <strong>OR</strong> (in maiuscolo).
    </small>
  </div>
  `,
  styles: [`.full-text-search {
    padding: 5px;
    margin-bottom: 20px;
    min-width: 100%;

    .search-controls {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 8px;
    }

    .search-field>input {
      min-width: 420px;
    }
  }

  .search-buttons {
    display: flex;

    >button {
      margin-right: 8px;
    }
  }`]
})

export class FulltextSearchComponent {
  @Output() clear: EventEmitter<void> = new EventEmitter<void>();
  @Output() search: EventEmitter<DocumentiFTSearchFilters> = new EventEmitter<DocumentiFTSearchFilters>();

  public searchTerm = '';
  public dataDocumento: Date[] | null = null;

  public doSearch(): void {
    this.search.emit({
      searchTerms: this.searchTerm,
      dataDal: this.dataDocumento?.[0] ?? null,
      dataAl: this.dataDocumento?.[1] ?? this.dataDocumento?.[0] ?? null
    });
  }

  public doClear(): void {
    this.searchTerm = '';
    this.dataDocumento = null;
    this.clear.emit();
  }
}
